export function UploadFileModel() {
  return {
    scope: {
      uploadFileModel: '=',
      uploadFileResult: '=?',
      multiple: '<',
    },
    link: (scope, element, attributes) => {
      const fileLoaded = (file, result) => {
        // Handle multiple file upload
        if (attributes.multiple) {
          // Add loaded file handler
          if (attributes.uploadFileModel) {
            if (!angular.isArray(scope.uploadFileModel)) {
              scope.uploadFileModel = [];
            }
            scope.uploadFileModel.push(file);
          }

          // Add loaded file result
          if (attributes.uploadFileResult) {
            if (!angular.isArray(scope.uploadFileResult)) {
              scope.uploadFileResult = [];
            }
            scope.uploadFileResult.push(result);
          }
        } else {
          // Handle single file upload
          scope.uploadFileModel = file;
          scope.uploadFileResult = result;
        }
      };
      element.bind('change', (changeEvent) => {
        let { files } = changeEvent.target;
        for (let i = 0; i < files.length; i++) {
          let file = files[i];
          let reader = new FileReader();
          reader.onload = (loadEvent) => {
            scope.$apply(() => {
              fileLoaded(file, loadEvent.target.result);
            });
          };
          reader.readAsDataURL(file);
        }
      });
    },
  };
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-file-upload/src/file-upload-model.directive.js